import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGooglIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.68 11.2285C20.68 10.5135 20.6158 9.82602 20.4967 9.16602H11V13.071H16.4267C16.1883 14.3268 15.4733 15.3902 14.4008 16.1052V18.6443H17.6733C19.58 16.8843 20.68 14.2993 20.68 11.2285Z",
			fill: "#4285F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9997 21.0841C13.7222 21.0841 16.0047 20.1858 17.673 18.6458L14.4005 16.1066C13.5022 16.7116 12.3564 17.0783 10.9997 17.0783C8.37805 17.0783 6.15055 15.3091 5.35305 12.9258H1.99805V15.5291C3.65721 18.8199 7.05805 21.0841 10.9997 21.0841Z",
			fill: "#34A853"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.35268 12.9155C5.15102 12.3105 5.03185 11.6688 5.03185 10.9996C5.03185 10.3305 5.15102 9.6888 5.35268 9.0838V6.48047H1.99768C1.31018 7.83714 0.916016 9.36797 0.916016 10.9996C0.916016 12.6313 1.31018 14.1621 1.99768 15.5188L4.61018 13.4838L5.35268 12.9155Z",
			fill: "#FBBC05"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9997 4.93102C12.4847 4.93102 13.8047 5.44435 14.8589 6.43435L17.7464 3.54685C15.9955 1.91518 13.7222 0.916016 10.9997 0.916016C7.05805 0.916016 3.65721 3.18018 1.99805 6.48018L5.35305 9.08352C6.15055 6.70018 8.37805 4.93102 10.9997 4.93102Z",
			fill: "#EA4335"
		})
	]
});
export default SvgGooglIcon;
